import React, {Component} from 'react';
import {Link, Switch, Route, Redirect} from 'react-router-dom';
import {Container} from 'reactstrap';
import Header from '../../components/Header/';
//import Sidebar from '../../components/Sidebar/';
import Breadcrumb from '../../components/Breadcrumb/';
//import Aside from '../../components/Aside/';
import Footer from '../../components/Footer/';

import Dashboard from '../../views/Dashboard/';
import partnerDashboard from '../../views/Dashboard/partnerDashboard';
import DSAReports from '../../views/Pages/DSAreports/DSAReports';
import LoanForm from '../../views/Pages/LoanForm/LoanForm';
import LoanDetails from '../../views/Pages/LoanApplicationDetails/LoanDetails';
import generateInvoice from '../../views/Pages/generateInvoice/generateInvoice';
//import InternalDsaSales from '../../views/Pages/InternalDsaSales/InternalDsaSales';

class Full extends Component {
  render() {
    return (
      <div className="app">
        <Header {...this.props}/>
        <div className="app-body">
          <main className="main">
            <Breadcrumb />
            <Container fluid>
              <Switch>
                <Route exact path="/dashboard" name="Dashboard" component={Dashboard}/>
                <Route exact path="/partnerDashboard" name="partnerDashboard" component={partnerDashboard}/>
                <Route path="/createLoan" name="Create Loan Application" component={LoanForm}/>
                <Route path="/dsareports" name="DSAReports" component={DSAReports}/>
                <Route path="/loanDetails/:id" name="Loan Details" component={LoanDetails}/>
                {/*<Route path="/generateInvoice" name="Generate Invoice" component={generateInvoice}/>*/}
                <Redirect from="#/dashboard" to="#/createLoan/"/>
              </Switch>
            </Container>
          </main>
        </div>
        <Footer />
      </div>
    );
  }
}

export default Full;



// WEBPACK FOOTER //
// ./src/containers/Full/Full.js